import { createApiClient } from "@polargold/pg-frontend-core";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";
import { ROUTE } from "@/router/routeDefinitions";
import router from "@/router";

const accessTokenStorage = new StorageHelper(StorageName.AccessToken, false);
const appLanguageStorage = new StorageHelper(StorageName.AppLanguage);

export const apiClient = createApiClient({
    baseURL: import.meta.env.VITE_DATASHEET_API_URL,
    getAccessToken: () => accessTokenStorage.read<string>(),
    getAcceptLanguage: () => appLanguageStorage.read<string>() || "de",
    getBasicAuthCredentials: () => {
        const password = import.meta.env.VITE_DATASHEET_BASIC_AUTH_PASSWORD;
        const username = import.meta.env.VITE_DATASHEET_BASIC_AUTH_USERNAME;

        if (!password || !username) return undefined;

        return { username, password };
    },
    onForbidden: async () => {
        await router.push({ name: ROUTE.PUBLIC_PAGE_NOT_ALLOWED.NAME });
    },
    onServerError: async () => {
        await router.push({ name: ROUTE.PUBLIC_ERROR_PAGE.NAME });
    },
});
